// gatsby-browser.js

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    console.log('Loading YouVisit script...');
    
    const script = document.createElement("script");
    script.src = "https://www.youvisit.com/tour/Embed/js3";
    script.async = false; // Load synchronously
    
    script.onload = () => {
      console.log('✓ YouVisit script loaded successfully');
      console.log('window.yvInit:', typeof window.yvInit);
      console.log('window.YV:', typeof window.YV);
    };
    
    script.onerror = (error) => {
      console.error('✗ YouVisit script failed to load:', error);
    };
    
    document.head.appendChild(script);
  }
};

export const onRouteUpdate = ({ location }) => {
  // Re-initialize YouVisit on route changes
  if (typeof window !== "undefined") {
    setTimeout(() => {
      console.log('Route updated, checking for YouVisit...');
      
      if (window.yvInit && typeof window.yvInit === 'function') {
        console.log('Calling yvInit on route update');
        window.yvInit();
      } else if (window.YV && typeof window.YV.createImmersiveBanners === 'function') {
        console.log('Calling createImmersiveBanners on route update');
        window.YV.createImmersiveBanners();
      } else {
        console.warn('YouVisit not available on route update');
      }
    }, 500);
  }

  // Your existing hash-scroll logic
  if (!location || !location.hash) return;

  const scrollToHash = () => {
    const scrollWithOffset = (el) => {
      const y = el.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: y, behavior: "smooth" });
    };

    const el = document.querySelector(location.hash);
    if (el) {
      scrollWithOffset(el);
    } else {
      let retries = 10;
      const interval = setInterval(() => {
        const target = document.querySelector(location.hash);
        if (target) {
          scrollWithOffset(target);
          clearInterval(interval);
        } else if (--retries <= 0) {
          clearInterval(interval);
          console.warn(`Element not found for hash: ${location.hash}`);
        }
      }, 100);
    }
  };

  setTimeout(scrollToHash, 0);
};